import React, { Component } from 'react'
import { Input, Menu } from 'antd'
import { connect } from 'react-redux'
import R from 'ramda'
import { fromNullable } from 'data.maybe'
// import { trendElements } from './trend-spec'
import { getContribKeys, getCAContribKeys, getMetrics } from '../selectors'
import { withRouter } from 'react-router'
const specToLink = props => (
  <Menu.Item style={{ margin: '0px' }} exact key={`${'/contrib'}/${props.id}`}>
    {props.display}
  </Menu.Item>
  //  <MenuItem key={`${props.id}-${props.group}`} prefix="/contrib" {...props} />
)

class ContribMenu extends Component {
  filterChanged = e => this.setState({ filterText: e.target.value })
  setSelectedKeys = selectedKeys => this.setState({ selectedKeys })
  render() {
    const { filterText, selectedKeys = '' } = this.state || {}
    const { style, metrics, contribKeys, caContribKeys } = this.props
    const matchFilter = str =>
      fromNullable(filterText)
        .map(t => t.toLowerCase())
        .map(t => str.toLowerCase().includes(t))
        .getOrElse(true)

    const createMenu = R.compose(
      R.map(specToLink),
      R.filter(spec => matchFilter(spec.id) || matchFilter(spec.display)),
      R.sortBy(m => m.display),
      R.filter(m => m),
      R.map(key => metrics[key])
    )

    const menuSelected = ({ key }) => {
      this.setSelectedKeys(key)
      //
      const { history } = this.props
      const location = { pathname: `${key}` }
      history.push(location)
    }

    return (
      <Menu
        selectedKeys={[selectedKeys]}
        // onSelect={({ key }) => this.setSelectedKeys(key)}
        onClick={menuSelected}
        style={{ ...style, height: '100%', width: '30%' }}
        theme="dark"
        mode="inline"
      >
        <Menu.Item>
          <Input
            icon="filter"
            placeholder="Filter..."
            value={filterText}
            onChange={this.filterChanged}
          />
        </Menu.Item>
        {createMenu(caContribKeys)}
        <div style={{ marginTop: '10px' }} />
        {createMenu(contribKeys)}
      </Menu>
    )
  }
}

const mapStateToProps = state => ({
  metrics: getMetrics(state),
  contribKeys: getContribKeys(state),
  caContribKeys: getCAContribKeys(state),
})

export default withRouter(connect(mapStateToProps)(ContribMenu))
